module.exports = __webpack_public_path__ + "img/SC.f7f59984.png";